document.addEventListener("DOMContentLoaded", function () {
  const fileInput = document.getElementById("invoice-file");
  const fileText = document.getElementById("file-text");
  const fileNameDisplay = document.getElementById("file-name-display");
  const fileNameText = document.getElementById("file-name-text");
  const errorMessage = document.getElementById("error-message");
  const invoiceDetailsFields = document.getElementById(
    "invoice-details-fields",
  );
  const invoicePreview = document.getElementById("invoice-preview");
  const actionButtons = document.getElementById("action-buttons");
  const invoiceDateField = document.getElementById("invoice-date");
  const reuploadBtn = document.getElementById("reupload-btn");
  const activateWarrantyBtn = document.getElementById("activate-warranty-btn");
  const invoiceSection = document.getElementById("upload-invoice-section");
  const invoiceLoader = document.getElementById("invoice-loader");
  const warrantyLoader = document.querySelector("#warranty-loader");

  let warrantyNumber = "";
  let serialId = "";
  let selectedFile = null;
  let pendingFormData = null;
  let isSubmitting = false;
const getToken = () => localStorage.getItem("token");

  const baseUrl = "https://ecom-api.tvsmotor.com/tvs_warranty";

  // ── JOURNEY TRACKER (shares session ID with warranty-registration.js) ──
  const TRACK_URL = `${baseUrl}/track-journey`;

  function getSid() {
    let sid = sessionStorage.getItem("_tvs_sid");
    if (!sid) {
      sid = crypto.randomUUID
        ? crypto.randomUUID()
        : Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem("_tvs_sid", sid);
    }
    return sid;
  }

  function track(step, options = {}) {
    try {
      const payload = JSON.stringify({
        sessionId: getSid(),
        step,
        status:   options.status   || "success",
        mobile:   options.mobile   || sessionStorage.getItem("_tvs_mobile") || null,
        metadata: options.metadata || null,
      });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(TRACK_URL, new Blob([payload], { type: "application/json" }));
      } else {
        fetch(TRACK_URL, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true });
      }
    } catch {}
  }
  // ───────────────────────────────────────────────────────────────

  // Inline error display — renders into a single container, no duplicates possible
  function showInlineError(message, type = "error") {
  let container = document.getElementById("warranty-error-message");

  if (!container) {
    container = document.createElement("div");
    container.id = "warranty-error-message";

    const anchor = actionButtons || document.body;
    anchor.parentNode
      ? anchor.parentNode.insertBefore(container, anchor)
      : document.body.appendChild(container);
  }

  container.style.display = "block"; // 👈 IMPORTANT

  const bgColor =
    type === "error" ? "#ff4757" : type === "success" ? "#1ef778" : "#ffa502";

  const textColor = type === "success" ? "#333" : "#fff";

  container.innerHTML = `
    <div style="
      display:flex;
      justify-content:space-between;
      padding:12px 16px;
      background:${bgColor};
      color:${textColor};
      border-radius:6px;
      margin-bottom:10px;
    ">
      <span>${message}</span>
      <button id="close-error">✕</button>
    </div>
  `;

  document.getElementById("close-error").onclick = () => {
    container.innerHTML = "";
  };

  setTimeout(() => {
    container.innerHTML = "";
  }, 5000);
} 
  function clearInlineError() {
    const container = document.getElementById("warranty-error-message");
    if (container) container.innerHTML = "";
  }

  // ================= FILE SELECT =================
  fileInput.addEventListener("change", async function (e) {
    const file = e.target.files[0];

    fileNameDisplay?.classList.remove("has-file");

    if (!file) return;

    // Check for supported file types
    const supportedTypes = ["application/pdf", "image/jpeg", "image/png"];
    const supportedExtensions = [".pdf", ".jpg", ".jpeg", ".png"];
    const fileName = file.name.toLowerCase();
    const isValidFile =
      supportedTypes.includes(file.type) ||
      supportedExtensions.some((ext) => fileName.endsWith(ext));

    if (!isValidFile) {
      showInlineError(
        "Please upload a valid PDF or image file (JPG, JPEG, PNG)",
        "error",
      );
      fileText.textContent = "Upload file";
      fileNameDisplay.style.display = "none";
      fileInput.value = "";
      return;
    }

    selectedFile = file;
    fileText.textContent = file.name;
    fileNameText.textContent = `Selected: ${file.name}`;
    fileNameDisplay.style.display = "block";
    fileNameDisplay.classList.add("has-file");

    // Disable file input after upload
    fileInput.disabled = true;

    preparePayload(file);

    // CALL PREVIEW API HERE
    await previewInvoice(file);
  });

  // ================= PREPARE FORM DATA =================
  function preparePayload(file) {
    document.getElementById("pdf-filename").textContent = file.name;
    document.getElementById("pdf-filesize").textContent =
      (file.size / 1024).toFixed(2) + " KB";

    const customerDataStr = sessionStorage.getItem("customerData");

    if (!customerDataStr) {
      showInlineError("Customer data missing. Please complete step 1.", "error");
      return;
    }

    const customerData = JSON.parse(customerDataStr);

    // Store serial ID for later use
    serialId = customerData.serial_id;

    pendingFormData = new FormData();
    pendingFormData.append("invoice", file, file.name);
    pendingFormData.append(
      "name",
      customerData.name || customerData.first_name,
    );
    pendingFormData.append("first_name", customerData.first_name);
    pendingFormData.append("email", customerData.email);
    pendingFormData.append("mobile", customerData.mobile);
    pendingFormData.append("serial_id", customerData.serial_id);
    pendingFormData.append(
      "terms_accepted",
      customerData.terms_accepted || customerData.agreedToTerms,
    );

  }

  // ================= PREVIEW API CALL =================
  async function previewInvoice(file) {
    try {
      // Show loader
      if (invoiceLoader) {
        invoiceLoader.style.display = "flex";
      }

      const formData = new FormData();
      formData.append("invoice", file);

      const res = await fetch(`${baseUrl}/preview-invoice`, {
        method: "POST",
          headers: {
            Authorization: `Bearer ${getToken()}`
  },

        body: formData,

      });

      // Check response status
      if (!res.ok) {
        let errorMsg = "Failed to upload file. Please try again.";

        if (res.status === 413) {
          errorMsg = "File is too large. Please upload a smaller file.";
        } else if (res.status === 400) {
          errorMsg = "Invalid file format. Please check and try again.";
        } else if (res.status === 500) {
          errorMsg = "Server error. Please try again later.";
        }

        showInlineError(errorMsg, "error");
        fileInput.value = "";
        fileInput.disabled = false;
        fileText.textContent = "Upload file";
        fileNameDisplay.style.display = "none";
        fileNameDisplay?.classList.remove("has-file");
        return;
      }

      const data = await res.json();

      if (!data.success) {
        showInlineError(
          data.message || "Failed to process PDF. Please try again.",
          "error",
        );
        fileInput.value = "";
        fileInput.disabled = false;
        fileText.textContent = "Upload file";
        fileNameDisplay.style.display = "none";
        fileNameDisplay?.classList.remove("has-file");
        return;
      }

      invoiceDateField.value = "";

      // STEP 2: only fill if API gives valid data
      const invoiceDate = data?.data?.invoiceDate || data?.data?.invoice_date;

      if (invoiceDate) {
        // Format date to DD/MM/YYYY format for text input field
        let formattedDate = invoiceDate;

        // If date is in YYYY-MM-DD format (ISO), convert to DD/MM/YYYY
        if (invoiceDate.includes("-") && invoiceDate.charAt(4) === "-") {
          const [year, month, day] = invoiceDate.split("-");
          formattedDate = `${day}/${month}/${year}`;
        }
        // If date is in DD-MM-YYYY format, convert to DD/MM/YYYY
        else if (invoiceDate.includes("-") && invoiceDate.charAt(2) === "-") {
          formattedDate = invoiceDate.replace(/-/g, "/");
        }
        // If date is already in DD/MM/YYYY format, keep it as is

        invoiceDateField.value = formattedDate;
      }

      // Add date input formatting
      // invoiceDateField.addEventListener("input", function (e) {
      //   let value = e.target.value.replace(/\D/g, ""); // Remove non-digits

      //   if (value.length >= 2) {
      //     value = value.slice(0, 2) + "/" + value.slice(2);
      //   }
      //   if (value.length >= 5) {
      //     value = value.slice(0, 5) + "/" + value.slice(5, 9);
      //   }

      //   e.target.value = value;
      // });

      // ================= PURCHASE CHANNEL LOGIC =================
      const purchaseChannelEl = document.getElementById("purchase-channel");
      const purchaseChannelWrapper = purchaseChannelEl?.closest(".form-group");
      const detectedChannel = (data.data.purchaseChannel || "")
        .toLowerCase()
        .trim();
      

      const knownChannels = ["amazon", "flipkart", "myntra", "website"];
      const isKnown =
        knownChannels.includes(detectedChannel) && detectedChannel !== "";

      // Remove old extracted text if already exists
      const oldSpan = purchaseChannelWrapper?.querySelector(
        "#detected-channel-text",
      );
      if (oldSpan) oldSpan.remove();

      if (purchaseChannelEl) {
        const svgArrow = purchaseChannelWrapper?.querySelector("svg");

        if (isKnown) {
          // Set value in dropdown
          purchaseChannelEl.value = detectedChannel;

          // Hide dropdown and SVG arrow
          purchaseChannelEl.style.display = "none";
          if (svgArrow) svgArrow.style.display = "none";

          // Show extracted text as plain text
          const textSpan = document.createElement("p");
          textSpan.id = "detected-channel-text";
          textSpan.textContent =
            detectedChannel.charAt(0).toUpperCase() + detectedChannel.slice(1);
          textSpan.style.cssText =
            "margin:0; padding: 10px 14px; font-size: 14px; color: #333; border: 1px solid #ddd; border-radius: 6px; background: #f9f9f9;";
          purchaseChannelWrapper
            ?.querySelector(".input-with-icon")
            ?.appendChild(textSpan);
        } else {
          // Unknown or empty → show dropdown manually
          purchaseChannelEl.value = "";
          purchaseChannelEl.style.display = "block";
          if (svgArrow) svgArrow.style.display = "block";
        }
      }

      // AUTO FILL ADDRESSES
      if (document.getElementById("billing-address")) {
        document.getElementById("billing-address").value =
          data.data.billingAddress || "";
      }

      if (document.getElementById("shipping-address")) {
        document.getElementById("shipping-address").value =
          data.data.shippingAddress || "";
      }

      // UI show
      invoiceSection.classList.add("invoice-uploaded");
      invoiceDetailsFields.style.display = "grid";
      invoicePreview.style.display = "block";
      actionButtons.style.display = "flex";
      track("invoice_uploaded");
    } catch (err) {
      console.error("Preview error:", err);
      showInlineError(
        "Failed to upload file. Please check your file and try again.",
        "error",
      );
      fileInput.value = "";
      fileInput.disabled = false;
      fileText.textContent = "Upload file";
      fileNameDisplay.style.display = "none";
      fileNameDisplay?.classList.remove("has-file");
    } finally {
      // Hide loader
      if (invoiceLoader) {
        invoiceLoader.style.display = "none";
      }
    }
  }

  // Click on Back Button then Invoice form clear
  const backToCustomerInfoBtn = document.getElementById(
    "back-to-customer-info",
  );
  backToCustomerInfoBtn?.addEventListener("click", () => {
    resetForm();
    invoiceSection.classList.remove("invoice-uploaded");
  });

  // ================= ACTIVATE WARRANTY =================
  activateWarrantyBtn?.addEventListener("click", async function () {
    if (isSubmitting) return; // prevent duplicate submissions

    clearInlineError();

    try {
      // ===== VALIDATION =====

      // 1. Invoice upload check
      if (!pendingFormData) {
        showInlineError("Please upload invoice first.", "error");
        return;
      }

      // 2. Invoice Date check
      const invoiceDateVal = invoiceDateField?.value?.trim();
      if (!invoiceDateVal) {
        showInlineError("Invoice Date is required.", "error");
        invoiceDateField?.focus();
        return;
      }

      // Validate DD/MM/YYYY format
      const dateRegex =
        /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/(19|20)\d{2}$/;
      if (!dateRegex.test(invoiceDateVal)) {
        showInlineError("Please enter date in DD/MM/YYYY format.", "error");
        invoiceDateField?.focus();
        return;
      }

      // 3. Purchase Channel check
      const purchaseChannelEl = document.getElementById("purchase-channel");
      const purchaseChannelVal = purchaseChannelEl?.value?.trim();
      if (!purchaseChannelVal) {
        showInlineError("Please select Purchase Channel.", "error");
        purchaseChannelEl?.focus();
        return;
      }

      // Append to form data
      pendingFormData.set("purchase_channel", purchaseChannelVal);
      pendingFormData.set("invoice_date", invoiceDateVal);

      // Show warranty loader
      isSubmitting = true;
      if (warrantyLoader) {
        warrantyLoader.style.display = "flex";
      }

      activateWarrantyBtn.disabled = true;
      activateWarrantyBtn.textContent = "Activating...";

      const response = await fetch(`${baseUrl}/submit`, {
        method: "POST",
          headers: {
          Authorization: `Bearer ${getToken()}`, // JWT
          },

        body: pendingFormData,
        
      });

      const data = await response.json();
      console.log("🚀 Submit Response:", data);

      if (!data.success) {
        track("warranty_failed", { status: "failed", metadata: { reason: data.message } }); // ← ADD
        showInlineError(data.message || "Activation failed", "error");
        return;
      }

      warrantyNumber = data.warrantyNumber;
      track("warranty_activated");
      
      // Capture and store orderNumber from response
      const orderNumber = data.orderNumber || data.OrderNumber || data.order_number || '';
      // if (orderNumber) {
      //   // localStorage.setItem('orderNumber', orderNumber);
      //   console.log("Order Number saved:", orderNumber);
      // } else {
      //   console.warn("Order Number not found in response");
      // }

      if (typeof window.showWarrantyPopup === "function") {
        window.showWarrantyPopup(serialId, warrantyNumber);
      }
    } catch (err) {
      console.error(err);
      showInlineError(
        err.message || "An error occurred. Please try again.",
        "error",
      );
    } finally {
      isSubmitting = false;
      // Hide warranty loader
      if (warrantyLoader) {
        warrantyLoader.style.display = "none";
      }

      activateWarrantyBtn.disabled = false;
      activateWarrantyBtn.textContent = "Activate Warranty";
    }
  });

  // ================= REUPLOAD =================
  reuploadBtn?.addEventListener("click", function () {
    fileInput.disabled = false;
    fileInput.click();
  });

  // ================= RESET =================
  function resetForm() {
    fileInput.value = "";
    fileInput.disabled = false;
    fileText.textContent = "Upload file";
    fileNameDisplay.style.display = "none";
    fileNameDisplay?.classList.remove("has-file");
    invoiceDetailsFields.style.display = "none";
    invoicePreview.style.display = "none";
    actionButtons.style.display = "none";
    invoiceDateField.value = "";

    // Reset purchase channel
    const purchaseChannelInput = document.getElementById("purchase-channel");
    if (purchaseChannelInput) {
      purchaseChannelInput.value = "";
      purchaseChannelInput.style.display = "block";
    }

    // Reset SVG arrow
    const purchaseChannelWrapper = purchaseChannelInput?.closest(".form-group");
    const svgArrow = purchaseChannelWrapper?.querySelector("svg");
    if (svgArrow) svgArrow.style.display = "block";

    // Remove extracted text
    const oldSpan = purchaseChannelWrapper?.querySelector(
      "#detected-channel-text",
    );
    if (oldSpan) oldSpan.remove();

    pendingFormData = null;
    selectedFile = null;

    const pdfContainer = document.getElementById("pdf-container");
    if (pdfContainer) pdfContainer.innerHTML = "";
  }
});